import { AlertRisksResponse, AlertDetails } from '../../API/types/Alerts';

export const renderItemsListTitle = (alertsAggregation: AlertRisksResponse | undefined):string => {
  let totalCount = 0;
  if (alertsAggregation) {
    totalCount = Object.values(alertsAggregation)
      .reduce((previousValue, currentValue) => previousValue + currentValue, 0);
  }
  const isPlural = alertsAggregation?.urgent === 1 ? 'alert' : 'alerts';
  return `${alertsAggregation?.urgent || 0} urgent ${isPlural} of ${totalCount}`;
};

export const getAlertDriverPhotoUrl = (alert?: AlertDetails): string | null => {
  if (!alert) {
    return null;
  }

  return alert.unknownDriverPhotoUrl || alert.unAuthorizedDriverPhotoUrl || null;
};

export const getAlertThumbnail = (alert?: AlertDetails): string | null => {
  const driverPhotoUrl = getAlertDriverPhotoUrl(alert);
  if (driverPhotoUrl) {
    return driverPhotoUrl;
  }

  if (alert?.sensor === 'inwardCamera' || alert?.sensor === 'cloud') {
    return alert?.thumbnailInwardCameraUrl || alert?.thumbnailFrontCameraUrl || null;
  }

  return alert?.thumbnailFrontCameraUrl || alert?.thumbnailInwardCameraUrl || null;
};
